export default {
  range: function (min, max) {
    let array = [],
      j = 0;
    for (let i = min; i <= max; i++) {
      array[j] = i;
      j++;
    }
    return array;
  },
  isInt: function (n) {
    return n % 1 === 0;
  },

  decimalSeparator: function () {
    const locale = navigator.language;
    const numberWithDecimalSeparator = 1.1;
    return Intl.NumberFormat(locale)
      .formatToParts(numberWithDecimalSeparator)
      .find((part) => part.type === "decimal").value;
  },

  getFormattedDecimal: function (number, fixed = true) {
    return number.toLocaleString(
      navigator.language,
      fixed ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : undefined
    );
  },
};
